<style lang="css">
.account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}
</style>
<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab0">选择平台企业</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab1">选择企业客户</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab2">选择个人客户</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="account-search-box">
        <vxe-input
          style="height: 34px !important"
          v-model="username"
          type="search"
          placeholder="搜索"
          @keyup.enter.native="search"
          @search-click="search"
        ></vxe-input>
      </div>
    </div>
    <div v-show="selectTab === 'tab0'">
      <vxe-table
        :loading="loading"
        show-overflow
        stripe
        highlight-current-row
        highlight-hover-row
        border="none"
        ref="xTable0"
        class="table-style"
        height="430"
        :auto-resize="true"
        :data="platData"
        @current-change="currentChangeEvent0"
      >
        <vxe-table-column field="name" title="企业名称"></vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="page0.currentPage"
        :page-size.sync="page0.pageSize"
        :total="page0.totalResult"
        @page-change="changePage0"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
        :loading="loading"
        show-overflow
        stripe
        highlight-current-row
        highlight-hover-row
        border="none"
        ref="xTable1"
        class="table-style"
        height="430"
        align="center"
        :auto-resize="true"
        :data="companyData"
        @current-change="currentChangeEvent1"
      >
        <vxe-table-column field="userName" title="客户名称"></vxe-table-column>
        <vxe-table-column field="compName" title="企业名称"></vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="page1.currentPage"
        :page-size.sync="page1.pageSize"
        :total="page1.totalResult"
        @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
        show-overflow
        stripe
        highlight-current-row
        highlight-hover-row
        border="none"
        ref="xTable2"
        class="table-style"
        height="430"
        align="center"
        :auto-resize="true"
        :data="personalData"
        @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="userName" title="客户名称"></vxe-table-column>
        <vxe-table-column field="realName" title="姓名"></vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="page2.currentPage"
        :page-size.sync="page2.pageSize"
        :total="page2.totalResult"
        @page-change="changePage2"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";

export default {
  name: "Account",
  data() {
    return {
      loading: false,
      selectTab: "tab1",
      username: null,
      companyData: [],
      personalData: [],
      platData: [],
      page0: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page1: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
    };
  },
  created() {},
  methods: {
    changePage0(e) {
      this.page0.currentPage = e.currentPage;
      this.page0.pageSize = e.pageSize;
      this.queryPlatList();
    },
    changePage1(e) {
      this.page1.currentPage = e.currentPage;
      this.page1.pageSize = e.pageSize;
      this.queryCompUserList();
    },
    changePage2(e) {
      this.page2.currentPage = e.currentPage;
      this.page2.pageSize = e.pageSize;
      this.queryPerUserList();
    },
    currentChangeEvent0({ row }) {
      this.$emit("choose", row, 0);
    },
    currentChangeEvent1({ row }) {
      this.$emit("choose", row, 1);
    },
    currentChangeEvent2({ row }) {
      this.$emit("choose", row, 2);
    },
    search() {
      if (this.selectTab === "tab1") {
        // 搜索企业用户列表
        this.page1.currentPage = 1;
        this.page1.pageSize = 10;
        this.queryCompUserList();
      } else if (this.selectTab === "tab2") {
        this.page2.currentPage = 1;
        this.page2.pageSize = 10;
        this.queryPerUserList();
      } else if (this.selectTab === "tab0") {
        this.page0.currentPage = 1;
        this.page0.pageSize = 10;
        this.queryPlatList();
      }
    },
    init() {
      this.selectTab = "tab0";
      this.username = null;
      this.page0.currentPage = 1;
      this.queryPerUserList();
      this.queryCompUserList();
      this.queryPlatList();
    },
    async queryPlatList() {
      this.loading = true;
      let res = await $api.department.get("listCompany", {
        name: this.username,
        orderBy: 2,
        page: this.page0.currentPage,
        rows: this.page0.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page0.totalResult = res.data.total;
        this.platData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryPerUserList() {
      this.loading = true;
      let res = await $api.gcdUser.request("queryUserListWithoutPermission", {
        username: this.username,
        userType: 1,
        orderBy: 2,
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page2.totalResult = res.data.total;
        this.personalData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryCompUserList() {
      this.loading = true;
      let res = await $api.gcdUser.request("queryUserListWithoutPermission", {
        username: this.username,
        userType: 2,
        orderBy: 2,
        page: this.page1.currentPage,
        rows: this.page1.pageSize,
      });
      this.loading = false;
      if (res.status === 1) {
        this.page1.totalResult = res.data.total;
        this.companyData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.selectTab = "tab1";
      this.username = null;
      this.page1 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.page2 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable1.clearCurrentRow();
      this.$refs.xTable2.clearCurrentRow();
    },
  },
};
</script>

<style>
</style>